import React, { useState } from 'react';
import './image-preview.styles.css';

interface ImagePreviewProps {
  imageUrl: string;
  thumbnailUrl?: string;
  alt?: string;
  onClose: () => void;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
  imageUrl,
  thumbnailUrl,
  alt = 'Image preview',
  onClose
}) => {
 
  return (
    <div className="modal-overlay" onClick={onClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={onClose}>
              ×
            </button>
            <img src={imageUrl} alt={alt} className="full-image" />
          </div>
        </div>
  );
};
